import { Tokens } from '@/assets/tokens'
import { WideFormContent } from '@/components/core/WideForm/WideForm.component'
import { blinkingAnimation } from '@/components/derived/ManualCard/ManualCard.animations'
import styled, { css } from 'styled-components'

export const PromptFormContent = styled(WideFormContent)`
  gap: 2px;
`

export const Container = styled.div`
  width: 100%;
  min-height: 84px;
  height: fit-content;
  border-radius: 1.2rem;
  padding: 1.4rem 2rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  background-color: ${Tokens.ColorWhite};
`

export const ContainerName = styled.div`
  width: 18rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
`

export const LinksContainer = styled.div`
  width: 16rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const PolarityRow = styled.div<{ $expanded: boolean; $height: string }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  height: ${({ $expanded }) => ($expanded ? 'auto' : '60px')};
  min-height: ${({ $expanded }) => ($expanded ? '0' : '60px')};
  max-height: ${({ $expanded }) => ($expanded ? 'none' : '60px')};
  transition: all 0.3s ease;
  flex-shrink: 0;
`

export const Polarity = styled.div<{ $expanded: boolean }>`
  width: 100%;
  border: 1px solid #dee2ef;
  border-radius: 12px;
  overflow: ${({ $expanded }) => ($expanded ? 'visible' : 'hidden')};
  display: flex;
  flex-direction: column;
  height: ${({ $expanded }) => ($expanded ? 'auto' : '100%')};
  min-height: ${({ $expanded }) => ($expanded ? '0' : 'auto')};
  background-color: ${({ $expanded }) => ($expanded ? 'transparent' : Tokens.ColorBackground)};
`

export const ExpandButton = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background-color: ${Tokens.ColorWhite};
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
  margin-top: 0;
  align-self: flex-start;

  &:hover {
    background-color: ${Tokens.ColorHover};
  }

  &:active {
    transform: scale(0.95);
  }
`

export const HealthCheckStatus = styled.div<{ $status: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 2px solid ${Tokens.ColorUIPrimaryDim};
  box-shadow: 0 0 6px ${Tokens.ColorUIPrimaryDim};
  background-color: ${Tokens.ColorUIPrimary};

  ${({ $status }) =>
    !$status &&
    css`
      border: 2px solid ${Tokens.ColorUIDangerDim};
      box-shadow: 0 0 6px ${Tokens.ColorUIDangerDim};
      background-color: ${Tokens.ColorUIDanger};
      animation: ${blinkingAnimation} 1s ease-in-out infinite;
    `}
`

export const PolarityHeader = styled.div<{ $expanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background-color: ${Tokens.ColorBackground};
  cursor: ${({ $expanded }) => ($expanded ? 'default' : 'pointer')};
  flex-shrink: 0;
  border-radius: 12px 12px 0 0;
`

export const PolarityTitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
`

export const PolarityStatusSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const SmallPolarityEmoji = styled.div`
  transform: scale(0.8);
  transform-origin: center;
`

export const PolarityTermsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background-color: ${Tokens.ColorBackground};
  flex: none;
`

export const TermsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 16px;
`

export const TermSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const PolarityRowsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
`

export const SaveButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid #dee2ef;
  flex-shrink: 0;
  margin-top: 24px;
`

export const SaveButton = styled.div`
  min-width: 180px;
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 2rem;
`

export const SubtitleContainer = styled.div`
  span {
    strong {
      font-weight: 600;
    }
  }
`
